import { apiService } from './api';

// The buyer never sends a phone number. Every call names the RESOURCE being
// opened — which is already in the URL the student followed — and the server
// resolves which number a code should go to. A page that could nominate a
// number could mint a session for one it controls.
//
// Every call opts out of the global 401 handler: verify-otp answers 401 on a
// wrong code, and that has to stay a field error rather than tearing down the
// screen being typed into.
const SKIP_AUTH = { skipAuthHandler: true };

const buyerAuthService = {
  getSession: ({ resourceType, resourceId }) => apiService.get(
    'view/buyer/session',
    resourceType && resourceId ? { resourceType, resourceId } : null,
    {},
    SKIP_AUTH,
  ),

  sendOtp: ({ resourceType, resourceId }) => apiService.post(
    'view/buyer/send-otp',
    { resourceType, resourceId },
    {},
    SKIP_AUTH,
  ),

  verifyOtp: ({ resourceType, resourceId, code }) => apiService.post(
    'view/buyer/verify-otp',
    { resourceType, resourceId, code },
    {},
    SKIP_AUTH,
  ),

  autologin: ({ resourceType, resourceId, token }) => apiService.post(
    'view/buyer/autologin',
    { resourceType, resourceId, token },
    {},
    SKIP_AUTH,
  ),

  logout: () => apiService.post('view/buyer/logout', {}, {}, SKIP_AUTH),
};

export default buyerAuthService;
